import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import { error } from 'console';
import { ENCUESTA_SATISFACCION_ENABLED, EncuestaService } from 'src/app/services/Encuesta/encuesta.service';
import { OrderService } from 'src/app/services/pedidos/pedidos.service';

type RatingKey = 'delivery' | 'operator' | 'product' | 'signature';

@Component({
    selector: 'app-aridos-encuesta-satisfaccion',
    templateUrl: './encuesta-satisfaccion.component.html',
    styleUrls: ['./encuesta-satisfaccion.component.css'],
    standalone: false
})
export class AridosEncuestaSatisfaccionComponent {
  readonly encuestaEnabled = ENCUESTA_SATISFACCION_ENABLED;

  @Input() isSurveyVisible: boolean = false;

  // ✅ Permite [(isSurveyVisible)] en el padre
  @Output() isSurveyVisibleChange = new EventEmitter<boolean>();

  // ✅ Para que el padre sepa que se envió con éxito
  @Output() surveySubmittedSuccessEvent = new EventEmitter<any>();

  // (Opcional) si quieres avisar errores
  @Output() surveySubmittedErrorEvent = new EventEmitter<any>();

  @Input() receiverName: string = '';

  stars = [1, 2, 3, 4, 5];

  ratings: Record<RatingKey, number> = {
    delivery: 0,
    operator: 0,
    product: 0,
    signature: 0,
  };
  user = {
    MAIL_USUARIO: '',
    NOMBRE_EMPRESA: "",
    RUT_USUARIO: "",
    RUT_EMPRESA: "",
    NOMBRE_USUARIO: ""
  }
  comment = '';
  isSubmitting = false;
  order = { workCode: '', workName: '', folioNumberGD: 0 , clientName:'', clientCode:''}

  constructor(private encuestaService: EncuestaService, private readonly orderService: OrderService, private route: ActivatedRoute,

  ) { }
  async ngOnInit() {
    if (!this.encuestaEnabled) return;

    const tktParam = this.route.snapshot.queryParamMap.get('tkt'); // "445319"
    const tkt = Number(tktParam);

    (await this.orderService.getAllOrders()).subscribe((data) => {
      // console.log('data:', data);

      this.order = data.find(x => Number(x.tkt) === tkt);
      // console.log('order:', this.order);
    });
  }

  openSurvey() {
    this.isSurveyVisibleChange.emit(true);
  }

  closeSurvey() {
    this.isSurveyVisibleChange.emit(false);
  }

  setRating(key: RatingKey, value: number) {
    this.ratings[key] = value;
  }

  isStarOn(key: RatingKey, star: number): boolean {
    return star <= this.ratings[key];
  }

canSubmit(): boolean {
  // const r = this.ratings;
  // const hasComment = this.comment.trim().length > 0;

  // return (
  //   r.delivery > 0 &&
  //   r.operator > 0 &&
  //   r.product > 0 &&
  //   r.signature > 0 &&
  //   hasComment
  // );

  return true
}

  submitSurvey() {
    if (!this.canSubmit() || this.isSubmitting) return;

    this.isSubmitting = true;

    const preguntas = [
      'Despacho (Entrega)',
      'Atención del operador',
      'Producto',
      '¿Qué tan fácil fue firmar digitalmente tu guía?',
    ];

    const puntos = [
      this.ratings.delivery,
      this.ratings.operator,
      this.ratings.product,
      this.ratings.signature,
    ].join(',');
    this.user = JSON.parse(localStorage.getItem('user') || '{}');

    const data = {
      pregunta: preguntas,
      puntos,
      comentario: this.comment.trim(),
      CodObra: this.order.workCode, // 👈 se mantiene igual que antes
      NombreObra: this.order.workName,  // 👈 se mantiene igual
      NroGuia: this.order.folioNumberGD, // 👈 SaveEncuesta lo espera; si no lo tienes, manda vacío
      Email: this.user.MAIL_USUARIO,
      NomEmp: this.order.clientName,
      RutUser: this.user.RUT_USUARIO,
      RutCli: this.order.clientCode,
      NomUser: this.receiverName
    };

    this.encuestaService.SaveEncuesta(data).subscribe({
      next: (res) => {
        this.isSubmitting = false;
        this.surveySubmittedSuccessEvent.emit(res); // ✅ avisa al padre
        this.closeSurvey();                         // ✅ cierra modal
      },
      error: (err) => {
        console.error(err);
        // this.isSubmitting = false;
        // this.surveySubmittedErrorEvent.emit(err);
      },
    });
  }

}

